import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';

export const createFundraiserDonationUserDataObject = (donation) => {
  const isCompany = getIn(donation, 'donorType') === 'Company';
  const firstName = getIn(donation, 'donorFirstName');
  const lastName = getIn(donation, 'donorLastName');
  const company = !isCompany ? '' : getIn(donation, 'donorCompanyName');

  return {
    firstName,
    lastName,
    company,
    country: 'SE',
    countryName: 'Sweden',
  };
};
